
import Label from './label.vue'
import ArticleLists from './articleLists.vue'
import Message from './message.vue'
import Banner from './banner.vue'
import Plate from './plate.vue'
import Notice from './notice.vue'
import Express from './express.vue'
export default {
  Label,
  ArticleLists,
  Message,
  Banner,
  Plate,
	Notice,
	Express
}



// WEBPACK FOOTER //
// ./src/views/content/index.js